const routes = [
  {
    path: "/manutencao-funcao-lotacao",
    name: "manutencao-funcao-lotacao",
    meta: {
      allowedPermissions: ["funcao_list"],
      breadCrumb: "Lotação de Servidores - Tabelas Básicas",
    },
    component: () =>
      import("@/views/ManutencaoFuncaoLotacao/ManutencaoFuncaoLotacaoHome.vue"),
  },
  {
    path: "/manutencao-funcao-lotacao/novo",
    name: "manutencao-funcao-lotacao-novo",
    meta: {
      allowedPermissions: ["funcao_insert"],
      breadCrumb: "Lotação de Servidores - Tabelas Básicas",
    },
    component: () =>
      import("@/views/ManutencaoFuncaoLotacao/ManutencaoFuncaoLotacaoCad.vue"),
  },
  {
    path: "/manutencao-funcao-lotacao/editar/:id",
    name: "manutencao-funcao-lotacao-editar",
    meta: {
      allowedPermissions: ["funcao_update"],
      breadCrumb: "Lotação de Servidores - Tabelas Básicas",
    },
    component: () =>
      import("@/views/ManutencaoFuncaoLotacao/ManutencaoFuncaoLotacaoEdit.vue"),
  },
];

export default routes;
